/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/comp.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const compPage: ICoinPageData = {
  title: 'coin_235',
  description: 'coin_236',
  // description: 'coin_237',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Compound (COMP)' }) }}
    />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_238',
        answer: 'coin_239',
      },
      {
        title: 'coin_240',
        answer: 'coin_241',
      },
      {
        title: 'coin_242',
        answer: 'coin_243',
      },
      {
        title: 'coin_244',
        answer: 'coin_245',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('FLR'),
    text: [],
    paragraphs: [
      {
        title: 'coin_246',
        text: ['coin_248'],
      },
      {
        title: 'coin_247',
        text: ['coin_249'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'How Crypto Assets Are Secured on CoinRabbit',
      },
      {
        link: 'https://coinrabbit.io/blog/usdc-vs-usdt-which-stablecoin-to-use/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_2400/https://coinrabbit.io/blog/wp-content/uploads/2023/09/will-be-listed.jpg',
        imageAlt: 'USDC vs. USDT: Which Stablecoin to Use',
      },
      blogCards.borrowLikePro,
    ],
  },
}
